import React from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface TestimonialCardProps {
  name: string;
  relationship: string;
  image: string;
  alt: string;
  quote: string;
  yearsMarried?: number;
}

const TestimonialCard = ({ 
  name, 
  relationship, 
  image, 
  alt,
  quote, 
  yearsMarried 
}: TestimonialCardProps) => {
  return (
    <div className="bg-card rounded-lg p-6 shadow-sacred-md hover:shadow-sacred-lg transition-all duration-300">
      <div className="flex items-start space-x-4 mb-4">
        <div className="relative w-16 h-16 flex-shrink-0 rounded-full overflow-hidden border-2 border-primary/20">
          <AppImage
            src={image}
            alt={alt}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1">
          <h4 className="font-playfair text-lg font-semibold text-foreground">
            {name}
          </h4>
          <p className="font-inter text-sm text-muted-foreground">
            {relationship}
          </p>
          {yearsMarried && (
            <p className="font-inter text-xs text-accent mt-1">
              Married {yearsMarried} years
            </p>
          )}
        </div>
      </div>
      
      <div className="relative">
        <Icon name="ChatBubbleLeftIcon" size={24} className="absolute -top-2 -left-2 text-primary/20" variant="solid" />
        <p className="font-inter text-sm text-foreground leading-relaxed pl-6 italic">
          "{quote}"
        </p>
      </div>
    </div>
  );
};

export default TestimonialCard;